import { specialConfigs } from './config.ts';
import type { FilterData } from './types.ts';

const normaliseValue = (value: FilterData['value']) =>
  Array.isArray(value) ? [...new Set(value.map(String))].sort() : String(value);

export const isSameFilter = (
  a: Pick<FilterData, 'type' | 'comparator' | 'value'>,
  b: Pick<FilterData, 'type' | 'comparator' | 'value'>,
) =>
  a.type === b.type &&
  a.comparator === b.comparator &&
  JSON.stringify(normaliseValue(a.value)) ===
    JSON.stringify(normaliseValue(b.value));

/**
 * Required filters are injected by the selected group by and can't be edited
 * or removed by the user.
 */
export const isRequiredFilter = (filter: FilterData) =>
  Object.hasOwn(specialConfigs, filter.id);

export const appendFilter = (
  currentFilters: FilterData[],
  filter: FilterData,
): FilterData[] =>
  currentFilters.some((f) => isSameFilter(f, filter))
    ? currentFilters
    : [...currentFilters, filter];

/**
 * Replaces the filter with `replacesId`. If the edited filter now duplicates
 * another existing filter, the edited filter is dropped instead. If the filter
 * being replaced no longer exists, the edited filter is appended.
 */
export const replaceFilter = (
  currentFilters: FilterData[],
  filter: FilterData,
  replacesId: string,
): FilterData[] => {
  if (!currentFilters.some((f) => f.id === replacesId)) {
    return appendFilter(currentFilters, filter);
  }

  return currentFilters.some(
    (f) => f.id !== replacesId && isSameFilter(f, filter),
  )
    ? currentFilters.filter((f) => f.id !== replacesId)
    : currentFilters.map((f) => (f.id === replacesId ? filter : f));
};
